import bg1 from './../../assets/expBg/1.jpg'
import bg2 from './../../assets/expBg/2.jpg'
import bg3 from './../../assets/expBg/3.jpg'
export const dataExp = [
  {
    bg: bg2,
    feature: 'Practice',
    desc: 'Hone your problem solving skills by solving the curated list of DSA prepared by the experts.',
    action: "Let's Solve",
    link: '/Practice',
  },
  {
    bg: bg1,
    feature: 'Contest',
    desc: 'Participate in a coding contest to check your readiness for placements.',
    action: "Let's Compete",
    link: '/Contest',
  },
  {
    bg: bg3,
    feature: 'Courses',
    desc: 'Explore the handpicked courses and learn from the best courses out there.',
    action: "Let's Learn",
    link: '/Courses',
  },
]
